import Input from "app/components/Input";
import TicketTypeIcon from "app/components/TicketTypeIcon";
import React from "react";

export default function TicketInput({
  form,
  ticketTypes,
  selectedIcon,
  handleChange,
  handleInputKeyDown,
  loading,
}: any) {
  return (
    <Input
      icon={<TicketTypeIcon iconName={selectedIcon as string} size={20} />}
      type="text"
      id="title"
      name="title"
      value={form?.title}
      onChange={handleChange}
      className="w-full text-sm leading-[21px] font-medium focus:outline-none"
      inputClassName="!h-[20px] px-[6px]"
      placeholder={`Enter ${ticketTypes
        ?.find((x: any) => x?._id === form?.type)
        ?.name?.toLowerCase()} name`}
      autoFocus
      noBorder
      onKeyDown={handleInputKeyDown}
      containerClassName="w-full"
      disabled={loading}
    />
  );
}
